export class TableSortConfigException extends Error {
  constructor(message?: string) {
    super(message);
  }
}
